/**
 * Phase 129 (Plan 129-07, D-04) — the board header's entry link to a project's Engineering tab.
 *
 * Shown only when the viewer is internal and the server's team-membership probe answers 200
 * (`member: true`). The probe is the authority, so a plain assigned member (who gets no project
 * link today) has an entry point while an outsider sees nothing. For the external audience the
 * probe is disabled and nothing renders. Presentation only: the Engineering routes enforce the
 * team gate themselves.
 */
import { Link } from 'react-router-dom';
import { useProjectEngineeringAccess } from '../../hooks/useProjectEngineering';

export interface ProjectEngineeringLinkProps {
  projectId: number;
  audience: 'internal' | 'external';
}

export function ProjectEngineeringLink({ projectId, audience }: ProjectEngineeringLinkProps) {
  const access = useProjectEngineeringAccess(projectId, audience === 'internal');

  if (audience !== 'internal' || access.data?.member !== true) return null;

  return (
    <Link
      to={`/projects/${projectId}/edit?tab=engineering`}
      className="shrink-0 rounded-lg border border-ms-border bg-ms-surface px-2 py-0.5 text-xs font-medium text-ms-text hover:bg-ms-canvas"
    >
      Engineering
    </Link>
  );
}
